import React from 'react';
import ReactDOM from 'react-dom/client'
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ThemeProvider } from '@mui/material/styles';
import { HelmetProvider } from 'react-helmet-async';
import theme from './theme';
import { ConsentProvider } from './Components/CookieConsent/ConsentContext';

const root = document.getElementById('root');
ReactDOM.createRoot(root).render(
  <React.StrictMode>
    <HelmetProvider>
      <ConsentProvider>
        <ThemeProvider theme={theme}>
          <App />
        </ThemeProvider>
      </ConsentProvider>
    </HelmetProvider>
  </React.StrictMode>,
  root
);

reportWebVitals();
